import React, { FC, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/system";
import { GAPS, SPACINGS } from "../common/consts";
import Card from "../components/Display/Card";
import Text, { TextVariant } from "../components/Display/Text";
import Link from "../components/Display/Link";
import ExtensionSection from "../components/Extension/ExtensionSection";
import { useCrmName } from "../components/CrmUi/useCrm";

const Page = styled("div")`
  display: flex;
  justify-content: center;
  padding: ${SPACINGS.xl};
`;

const Content = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: ${GAPS.md};
  max-width: 560px;
  width: 100%;
`;

/**
 * Landing page the extension opens when it needs a session. Connecting is
 * automatic when the extension is installed and signed out.
 */
const ConnectExtension: FC = () => {
  const navigate = useNavigate();
  const [done, setDone] = useState(false);
  const crmName = useCrmName();

  const onConnected = useCallback(() => {
    setDone(true);
  }, []);

  return (
    <Page>
      <Content>
        <Text variant={TextVariant.h4}>Connect the boring extension</Text>
        <Text variant={TextVariant.sm}>
          {done
            ? `The extension is signed in. You can close this tab and go back to ${crmName}.`
            : "This signs the Chrome extension in with your boring account."}
        </Text>
        <ExtensionSection autoConnect onConnected={onConnected} />
        <Link path="/app/dashboard" onClick={() => navigate("/app/dashboard")}>
          Go to dashboard
        </Link>
      </Content>
    </Page>
  );
};

export default ConnectExtension;
